module.exports = __webpack_public_path__ + "static/HBR_LatestFeed-2ed2f42c142a1ef490b049de1e1fc94b.mp4";